import { render, staticRenderFns } from "./changepsw.vue?vue&type=template&id=cf5b8364"
import script from "./changepsw.vue?vue&type=script&lang=js"
export * from "./changepsw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports